import type { FormatterMap, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createCheckoutFormatters,
  createMyAccountFormatters,
  productDetailFormatters,
} from '@grandvisionhq/www-next/formatters'

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),
  'auth.login': createSimpleFormatter('my-account/login'),
  'auth.callback': createSimpleFormatter('my-account/callback'),
  'auth.reset': createSimpleFormatter('my-account/reset'),
  'auth.activate': createSimpleFormatter('my-account/activate'),
  'auth.logout': createSimpleFormatter('my-account/logout'),
  'auth.logged-out': createSimpleFormatter('my-account/logged-out'),
  'cart.overview': createSimpleFormatter('cart'),
  'appointments.book': createSimpleFormatter('book-appointment-v3'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  ...createMyAccountFormatters(),
  'express-checkout': createSimpleFormatter('express-checkout'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: {
      login: 'login',
      shipping: 'livraison',
      overview: 'recapitulatif',
      payment: 'paiement',
    },
  }),
  ...productDetailFormatters({
    accessories: 'acessorios',
    'contact-lenses': 'lentilles',
    frames: 'lunettes-de-vue',
    'ready-readers': 'lunettes-premontees',
    solutions: 'lentilles/entretien',
    sunglasses: 'lunettes-de-soleil',
  }),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/my-account/login', 'auth.login'],
  ['/my-account/signup', 'auth.signup'],
  ['/my-account/callback', 'auth.callback'],
  ['/my-account/reset', 'auth.reset'],
  ['/my-account/activate', 'auth.activate'],
  ['/my-account/logout', 'auth.logout'],
  ['/my-account/logged-out', 'auth.logged-out'],
  ['/my-account/profile', 'me.profile'],
  ['/my-account/change-password', 'auth.change-password'],
  ['/my-account/reset-password', 'auth.reset-password'],
  ['/my-account/settings', 'me.settings'],
  ['/my-account/settings/change-password', 'auth.change-password'],
  ['/my-account/settings/communication-preferences', 'me.settings.comms'],
  ['/my-account/orders', 'me.orders'],
  ['/my-account/orders/:orderId', 'me.orders.detail'],
  ['/my-account/prescriptions', 'me.prescription'],
  ['/my-account/appointments', 'me.appointments'],
  ['/my-account/appointments/:appointmentId', 'me.appointments.detail'],
  ['/my-account/subscriptions', 'me.subscriptions'],
  ['/my-account/subscriptions/:subscriptionId', 'me.subscriptions.detail'],

  ['/checkout/login', 'checkout.login'],
  ['/checkout/livraison', 'checkout.shipping'],
  ['/checkout/recapitulatif', 'checkout.overview'],
  ['/checkout/paiement', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/prendre-rendez-vous/(.*)?', 'appointments.book'],
  ['/modifier-rendez-vous', 'appointments.reschedule'],
  ['/annuler-rendez-vous', 'appointments.cancel'],
]
